import React from 'react'
import { Alert, Body1, Button, Display5, majorScale } from '@segment/react-ui-library'
import getProp from '@f/get-prop'

const defaultOptions = {
  path: 'error',
  title: 'Oops'
}

export default (opts = {}) => (Component) => {
  function withError (props) {
    const providedOptions = typeof opts === 'function' ? opts(props) : opts
    const options = Object.assign({}, defaultOptions, providedOptions)
    const hasError = getProp(options.path, props)

    return hasError
      ? <ErrorMessage {...props} {...options} />
      : <Component {...props} />
  }

  withError.displayName = `withError(${Component.displayName})`

  return withError
}

const ErrorMessage = (props) => {
  const { title, messaging, primaryButton } = props
  return (
    <Alert type='danger' marginX='auto' marginY={majorScale(8)}>
      <Display5>{title}</Display5>
      {messaging && <Body1>{messaging}</Body1>}
      {primaryButton && (
        <Button primary marginTop={majorScale(1)} onClick={(...args) => primaryButton.onClick(props, ...args)}>
          {primaryButton.children}
        </Button>
      )}
    </Alert>
  )
}



// WEBPACK FOOTER //
// ./hoc/withError.js